import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Router, RouterLink } from '@angular/router';
import { ApiService } from '../../services/api.service';

@Component({
  selector: 'app-sign-up',
  standalone: true,
  imports: [CommonModule, FormsModule, RouterLink],
  templateUrl: './sign-up.component.html',
})
export class SignUpComponent {
  private readonly phonePattern = /^\+?[0-9()\-\s]{7,20}$/;

  firstName = '';
  lastName = '';
  email = '';
  phone = '';
  password = '';

  loading = false;
  errorMessage = '';
  successMessage = '';

  constructor(private api: ApiService, private router: Router) {}

  private isValidPhone(phone: string): boolean {
    return !phone || this.phonePattern.test(phone);
  }

  submit(): void {
    this.errorMessage = '';
    this.successMessage = '';

    const trimmedPhone = this.phone.trim();
    const trimmedPassword = this.password.trim();

    if (!this.firstName.trim() || !this.lastName.trim() || !this.email.trim() || !trimmedPassword) {
      this.errorMessage = 'First name, last name, email and password are required.';
      return;
    }

    // if (!this.isValidPhone(trimmedPhone)) {
    //   this.errorMessage = 'Phone must be 7-20 characters and contain only digits, spaces, parentheses, hyphens, or a leading +.';
    //   return;
    // }

    this.loading = true;
    this.api
      .signUp({
        first_name: this.firstName.trim(),
        last_name: this.lastName.trim(),
        email: this.email.trim(),
        phone: trimmedPhone || null,
        password: trimmedPassword,
      })
      .subscribe({
        next: () => {
          this.loading = false;
          this.successMessage = 'Sign up successful. Please sign in.';
          this.router.navigate(['/sign-in']);
        },
        error: (err) => {
          this.loading = false;
          this.errorMessage = err?.error?.detail || 'Sign up failed.';
        },
      });
  }
}
